import { consumerQuoteKey } from '@shared/consumerPlan';
import { quotesNeededBy, type ConsumerStepId } from '../lib/steps';
import { useConsumerPlan } from './use-consumer-plan';
import { useConsumerQuotes } from './use-consumer-quotes';

/** Whether the quotes a step depends on are ready, failed, or no longer include the consumer's choice. */
export function useStepQuotes(clientId: string, step: ConsumerStepId) {
  const need = quotesNeededBy(step);
  const { quotes, isLoading, isError, refetch } = useConsumerQuotes(clientId);
  const { plan } = useConsumerPlan(clientId);

  const isWaiting = need !== 'none' && isLoading;
  const hasFailed = need !== 'none' && isError;
  const isChoiceMissing =
    need === 'chosenQuote' &&
    !isLoading &&
    !isError &&
    !quotes.some(quote => consumerQuoteKey(quote) === plan?.selectedQuoteKey);

  return { isWaiting, hasFailed, isChoiceMissing, retry: refetch };
}
